/** Allow only same-origin internal paths (blocks open redirects). */
export function getSafeRedirectPath(from, fallback = "/") {
    if (typeof from !== "string") return fallback;
    const path = from.trim();
    if (!path.startsWith("/") || path.startsWith("//")) return fallback;
    return path;
}
